// Tulevaisuustestaus v2 (#1474), the `futureV2` namespace in Swedish; split by language from
// futureReimaginedV2Strings.js (the Finnish, and the file's notes) when it neared 1000 lines.

export const futureReimaginedV2Sv = {
  loading: "Lösningarna laddas…",
  loadError: "Laddningen misslyckades: {{message}}",
  tooFew: "Växelverkan kan granskas när Lösningar har minst två bedömda lösningar. Nu finns det {{count}}.",
  unassessed: "Dessa lösningar har ännu inte bedömts och saknas därför i jämförelsen: {{names}}",
  offMap: "Skrivna på hävstångspunkter som Ongelmakartta inte längre visar (kartan kördes igen): {{names}}. Deras rörelser saknas i korsverkningarna och testet; bedöm dem igen i Ratkaisut.",
  views: {
    select: "Urval",
    analysis: "Analys",
    interplay: "Växelverkan",
    timeline: "Tidslinje",
    fates: "Öden",
    vipupisteet: "Hävstångspunkter",
    compare: "Jämförelse",
    needsCourse: "Analysen öppnas när den låsta uppsättningen lösningar har testats i scenarierna.",
    courseStatus: {
      beforeLock: "Analysen öppnas när lösningarna är låsta och facilitatorn har testat dem i scenarierna.",
      waiting: "Lösningarna är låsta. Analysen öppnas när facilitatorn har testat dem i scenarierna.",
      running: "Lösningarna testas i scenarierna… Analysen öppnas när testet är klart.",
      failed: "Det gick inte att föreställa framtiden. Facilitatorn kan starta det igen."
    },
  },
  stageBar: { label: "Skeden", interplay: "Växelverkan", voting: "Omröstning", locked: "Låsning", simulated: "Framtidstestning" },
  move: { as_intended: "Rör den åt sitt håll", against: "Rör den mot sitt håll" },
  matrix: {
    title: "Vad varje lösning rör",
    hint: "Raderna är lösningar, kolumnerna hävstångspunkter. Pilen kommer från lösningens bedömning: om den rör hävstångspunkten i dess egen förändringsriktning eller mot den.",
    sideEffect: "Bieffekt (inte eftersträvad)",
    untouched: "ingen lösning rör den",
  },
  candidates: {
    title: "Möjlig växelverkan",
    hint: "Beräknat utifrån lösningarnas bedömningar, hävstångspunkter och genomförandevägar: vad två lösningar har gemensamt. Det säger ännu inte om de stöder eller konkurrerar med varandra.",
    none: "Lösningarna har inga gemensamma hävstångspunkter eller aktörer.",
    all: "Visa alla {{count}} par",
    fewer: "Visa färre",
  },
  signal: {
    similarity: "Rör samma hävstångspunkter {{percent}} %",
    opposed: "Motsatta: {{name}}",
    same_harm: "Båda rör den mot sitt håll: {{name}}",
    same_good: "Båda rör: {{name}}",
    shared_target: "Skrivna på samma hävstångspunkt: {{name}}",
    shared_actor: "Samma aktör: {{name}} ({{horizon}})",
  },
  interplay: {
    title: "Växelverkan",
    hintUnread: "Nedan syns vad lösningarna har gemensamt enligt siffrorna. AI:n läser paren och säger om lösningarna överlappar, konkurrerar, står i konflikt, möjliggör eller förstärker varandra – eller inte påverkar varandra alls.",
    hintRead: "Linjerna är AI:ns tolkning av hur lösningarna påverkar varandra. Välj en lösning för att bara se dess relationer. Varje relation anger sin grund och osäkerhet.",
    waiting: "AI:n har ännu inte läst paren. Facilitatorn startar läsningen, och resultatet visas här när det är klart.",
    readAt: "Kuutios läsning, {{time}}",
    stale: "Lösningar har ändrats eller lagts till efter denna läsning ({{names}}). Facilitatorn kan läsa växelverkan igen före omröstningen.",
  },
  graph: { label: "Relationer mellan lösningarna" },
  relation: { conflict: "Konflikt", overlap: "Överlappning", competing: "Konkurrens", enables: "Möjliggör", reinforces: "Förstärker", independent: "Ingen påverkan" },
  strength: { low: "Liten betydelse", medium: "Måttlig betydelse", high: "Stor betydelse" },
  basis: { research: "forskning", reasoned: "resonemang" },
  cluster: { overlap: "Överlappande grupp:", competing: "Konkurrerande grupp:", dependency: "Vilar på en:" },
  relationCard: {
    why: "Varför: motiveringen, osäkerheten och grunden",
    uncertainty: "Osäkerhet: {{text}}",
    via: "Går via: {{list}}",
    basis: "Grund: {{basis}}",
    noneDrawn: "AI:n fann ingen överlappning, konkurrens, konflikt eller beroende mellan paren.",
    showIndependent: "Visa par som inte påverkar varandra ({{count}})",
    hideIndependent: "Dölj par som inte påverkar varandra ({{count}})",
    unanswered: "AI:n gav ingen bedömning för dessa par: {{pairs}}",
    ragUnavailable: "Forskningsmaterialet kunde inte nås, så relationerna vilar på resonemang.",
  },
  sources: { fold: "Källor ({{count}})", unavailable: "Källorna kunde inte hämtas den här gången." },
  vote: {
    title: "Omröstning: vilka lösningar behålls",
    hint: "Välj de lösningar som tas med till framtidstestningen. Varje kort visar vad läsningen av växelverkan kopplar lösningen till. Tryck igen för att ta tillbaka en röst.",
    left: "Röster kvar {{left}} / {{budget}}",
    noIdentity: "Den här enheten kan inte rösta. Logga in med workshopens PIN-kod.",
    vote: "Rösta: {{name}}",
    unvote: "Ta tillbaka rösten: {{name}}",
    warning: {
      conflict: "I konflikt med: {{name}}",
      overlap: "Överlappar: {{name}}",
      competing: "Konkurrerar med: {{name}}",
      needs: "Behöver först: {{name}}",
      enables: "Möjliggör: {{name}}",
      reinforces: "Förstärker: {{name}}"
    },
    error: {
      CLOSED: "Omröstningen är stängd.",
      BUDGET: "Du har inga röster kvar. Ta tillbaka en röst för att rösta på en annan.",
      NO_SOLUTION: "Lösningen finns inte längre.",
      NO_VOTER: "Enheten kändes inte igen som röstare.",
      generic: "Rösten kunde inte sparas: {{message}}"
    }
  },
  locked: {
    title: "Tas med till framtidstestningen",
    votes: "(röster: {{count}})",
    override: "Valet avviker från omröstningen. Facilitatorns motivering: {{reason}}",
    stale: "Dessa lösningar har redigerats efter låsningen: {{names}}. Den föreställda tidslinjen bygger på den låsta versionen.",
    deleted: "(raderad lösning)"
  },
  admin: {
    title: "Framtidstestning: omröstning och låsning",
    loadError: "Laddningen misslyckades: {{message}}",
    interplayRead: "Växelverkan har lästs.",
    interplayStale: "Växelverkan har lästs, men lösningar har ändrats sedan dess. Läs den igen före omröstningen med Bedöm växelverkan.",
    interplayMissing: "Växelverkan har inte lästs ännu. Det lönar sig att läsa den före omröstningen med Bedöm växelverkan.",
    votes: "Omröstningen är {{open}}, {{budget}} röster per enhet. Öppna och stäng omröstningen med brytaren ovan.",
    open: "öppen",
    closed: "stängd",
    tension: {
      overlap: "Överlappning i urvalet: {{a}} och {{b}}",
      conflict: "Konflikt i urvalet: {{a}} och {{b}}. Du kan ändå låsa; tidslinjen visar vad det kostar."
    },
    overrideHint: "Urvalet lämnar bort en lösning som fick fler röster än en vald. Dokumentera varför: rummet ser det och rapporten sparar det.",
    overridePlaceholder: "Varför avviker urvalet från omröstningen?",
    lock: "Lås {{count}} lösningar",
    relock: "Lås igen ({{count}})",
    lockFailed: "Låsningen misslyckades: {{message}}",
    openModule: "Öppna modulen",
    currentLock: "Nuvarande låsning ({{time}}): {{names}}"
  },
  howWeGotHere: "Hur vi kom hit: samspelet",
  actor: {
    label: "Aktör",
    all: "Alla",
    hint: "Välj din organisation: dess steg framhävs på tidslinjen. Valet sparas på den här enheten.",
    count: "{{name}}: {{count}} steg i det här förloppet",
    none: "{{name}} agerar inte i det här förloppet."
  },
  compare: {
    title: "Scenarierna sida vid sida",
    solution: "Lösning",
    set: "Hela uppsättningen",
    robustness: "Robusthet",
    lines: "Tidslinjerna på samma årsaxel",
    tooFew: "Det finns något att jämföra när minst två scenarier har föreställts."
  },
  course: {
    causes: "Motivering",
    title: "Föreställt förlopp: vad som kunde hända lösningarna",
    running: "Tidslinjen föreställs…",
    failed: "Det gick inte att föreställa tidslinjen: {{message}}",
    yearLikelihood: "{{year}} · {{likelihood}}",
    triggers: "Vad det beror på:",
    setAside: "Hot som inte bedöms förverkligas:",
    threat: "{{what}} ({{when}}, {{likelihood}})",
    relation: "{{relation}}: {{a}} – {{b}}",
    wouldChange: "Vad som skulle ändra detta: {{text}}",
    missing: "Inget grundat utfall kom för dessa lösningar: {{names}}",
    until: "till {{year}}",
    after: "först när {{name}} är igång"
  },
  effect: {
    title: "Effekt: hur långt lösningarna löser problemet",
    intro: "En bedömning av det här förloppet. Servern räknar ut vilka av hävstångspunkternas grundorsaker varje lösning når och sänker en bedömning som går längre än så.",
    verdict: {
      marginal: "Rör knappt problemet",
      eases: "Lindrar problemet",
      fixes: "Löser problemet",
      dissolves: "Upphäver problemets utgångspunkt"
    },
    short: {
      marginal: "Rör knappt",
      eases: "Lindrar",
      fixes: "Löser",
      dissolves: "Upphäver"
    },
    legend: {
      marginal: "lösningen når få eller inga av grundorsakerna, eller gör för lite i det här förloppet",
      eases: "problemet blir mindre eller mildare, men en stor del av grundorsakerna finns kvar",
      fixes: "de viktigaste grundorsakerna hanteras och problemet är i stort sett borta, även om systemet runt det är sig likt",
      dissolves: "ett paradigmskifte: grundorsakerna försvinner och problemets utgångspunkt är borta"
    },
    set: "Hela lösningsuppsättningen",
    perSolution: "Varje lösning",
    reached: "Når grundorsaker: {{names}}",
    reachedNone: "Når ingen av de grundorsaker hävstångspunkterna bär.",
    coverage: "{{reached}} av {{total}} grundorsaker",
    remaining: "Grundorsaker som ingen genomförd lösning når: {{names}}",
    premiseGone: "Varför problemets utgångspunkt försvinner: {{text}}",
    lowered: "AI:n bedömde: {{from}}. Utifrån kartan högst: {{to}} ({{reason}}).",
    loweredReason: {
      reaches_none: "lösningen når ingen grundorsak",
      reaches_under_half: "den når under hälften av grundorsakerna",
      reaches_under_most: "den når under fyra femtedelar av grundorsakerna",
      premise_not_argued: "den motiverade inte varför utgångspunkten försvinner",
      no_root_causes: "hävstångspunkterna bär inga grundorsaker att jämföra med"
    },
    unjudged: "AI:n bedömde inte den här lösningen.",
    newIssues: "Nya problem som genomförandet kunde ge upphov till",
    newIssuesHint: "Slutledningar, inte iakttagelser: de vilar på lösningarnas egna effekter och saknar källa.",
    followsFrom: "Följer av: {{names}}",
    grounded: {
      adverse_move: "Vilar på att lösningen rör en hävstångspunkt mot dess riktning",
      world_shift: "Vilar på en utveckling som lösningen flyttar",
      reasoned: "Enbart resonemang"
    },
    failed: "Effektbedömningen misslyckades: {{message}}",
    missing: "Effekten av det här förloppet har inte bedömts än.",
    wall: "Effekt: {{verdict}}"
  },
  fate: {
    realised: "Förverkligas",
    delayed: "Försenas",
    diminished: "Försvagas",
    failed: "Misslyckas"
  },
  impact: {
    title: "Scenariot och vad det gör",
    show: "Visa scenariots text",
    hide: "Dölj texten"
  },
  likelihood: {
    low: "osannolik",
    medium: "möjlig",
    high: "sannolik"
  },
  line: {
    scrollHint: "Svep i sidled →",
    step: "{{from}}–{{to}} · {{solution}}: {{step}}",
    stepActor: "Aktör: {{actor}}",
    stepPrecondition: "Förutsättning: {{text}}",
    close: "Stäng"
  },
  narrativeKind: {
    milestone: "Milstolpe",
    side_effect: "Bieffekt",
    setback: "Bakslag",
    turning_point: "Vändpunkt",
    interaction: "Möte"
  },
  panels: {
    stepCount: "{{count}} steg",
    highlights: "Vad man skulle märka längs vägen",
    actions: "Åtgärder per år",
    actionsFor: "Åtgärder per år · {{name}} först",
    noActions: "Förloppet har inga schemalagda steg."
  },
  reading: {
    title: "Vad scenariot gör med lösningarnas hot",
    pressure: {
      stronger: "förstärker",
      as_is: "lämnar oförändrat",
      weaker: "försvagar",
      removed: "tar bort"
    },
    timing: {
      earlier: "tidigare",
      same: "",
      later: "senare"
    },
    kind: {
      trigger: "orsakade utfallet",
      setAside: "hot som åsidosattes"
    },
    behind: "I scenariot: {{text}}",
    none: "Scenariot ändrar inte hoten bakom detta förlopps utfall.",
    differs: "Vad skiljer scenarierna åt",
    differsIntro: "Hoten och relationerna som scenarierna påverkar olika, med det ställe varje bedömning vilar på. Alla scenarier lästes på en gång, sida vid sida.",
    noDiffer: "Scenarierna skiljer sig inte i fråga om de låsta lösningarnas hot.",
    notRead: "Scenarierna har inte lästs än.",
    failed: "Läsningen av scenarierna misslyckades: {{message}}"
  },
  robustness: {
    title: "Robusthet: hur lösningarna klarar sig i olika förlopp",
    verdict: "Sammanfattning",
    holds: "Håller i alla förlopp",
    failsAll: "Misslyckas i alla förlopp",
    fails: "Misslyckas i något förlopp",
    diminishedAll: "Försvagas i alla förlopp",
    varies: "Varierar med förloppet",
    unknown: "Ingen information"
  },
  scenario: {
    label: "Scenario",
    sources: {
      expert: "Expertscenarier",
      workshop: "Workshopens scenarier",
      own: "Egna scenarier"
    },
    placeholder: "Platshållare: experternas scenarier ersätter dessa texter.",
    stale: "Scenariot har ändrats sedan detta förlopp: föreställ det igen.",
    read: "Läs scenariot",
    close: "Stäng",
    level: "Optimismnivå {{level}}",
    judged: "Lösningarna bedöms realistiskt i den här världen: varken milt eller strängt."
  },
  timeline: {
    label: "Det föreställda genomförandet av de låsta lösningarna år för år",
    today: "I dag",
    haze: "Prognosens osäkerhet växer ju längre in i framtiden den sträcker sig",
    noNarrative: "Berättelsen kunde inte skrivas; förloppet och utfallen finns ändå nedan. {{message}}"
  },
  worldAdmin: {
    title: "Scenarier",
    source: "Källa: {{source}}, {{count}} scenarier. Källan kan bytas under Sisältö (Prognosens scenarier).",
    none: "Den valda källan har {{count}} scenarier; minst {{min}} behövs. Byt källa eller lägg till scenarier under Sisältö.",
    simulate: "Föreställ alla scenarier",
    simulating: "Föreställer…",
    rerun: "Föreställ igen",
    analyse: "Bedöm effekten igen",
    analysing: "Bedömer…",
    readingStatus: {
      running: "läses",
      done: "läst",
      failed: "läsningen misslyckades"
    },
    status: {
      running: "föreställs",
      done: "klart",
      failed: "misslyckades"
    }
  },
  lockedStrip: {
    label: "Låst",
    override: "Valet avviker från omröstningen",
    stale: "ändrad efter låsningen"
  },
  vipupisteet: {
    title: "Vilka hävstångspunkter helheten rör när det går fel",
    hint: "För varje hävstångspunkt de låsta lösningarna rör: vilka lösningar som rör den åt sitt håll (↑) eller mot det (↓), och hur det går för dem i varje scenario. Inga siffror bedöms: bara om rörelsen sker.",
    type: { konsensus: "Gemensam syn", kiistanalainen: "Omstridd", villi_kortti: "Joker", sokea_piste: "Blind fläck" },
    holds: "Rör sig åt sitt håll i {{n}} av {{total}} scenarier",
    weakened: "försvagad i {{n}}",
    against: "mot sitt håll i {{n}}",
    solution: "Lösning",
    noFate: "inget öde",
    none: "De låsta lösningarna rör ingen av de visade hävstångspunkterna.",
  },
  wall: { title: "Framtidstestning", intro: "Varje lösning har bedömts för sig, per hävstångspunkt. Här ser vi vad de gör med varandra, väljer vilka som behålls och föreställer oss hur den valda helheten kunde förverkligas. Det är en vision, inte en prognos: osäkerheterna sägs öppet.", vision: "En vision, inte en prognos: varje ögonblick vilar på lösningarnas egna hot och relationerna mellan dem, och dess osäkerhet anges." },
};
